// extracted by mini-css-extract-plugin
export default {"body":"DeleteOutlineSectionsModal_body__QpEqZ"};